// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__35q2F","footer":"ModalCreateQualiphyProcedure_footer__5itu2","additionData":"ModalCreateQualiphyProcedure_additionData__yp8_2"};